import { render, staticRenderFns } from "./ProjectBookAssistant.vue?vue&type=template&id=0cbbec8c&scoped=true&lang=pug&"
import script from "./ProjectBookAssistant.vue?vue&type=script&lang=ts&"
export * from "./ProjectBookAssistant.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cbbec8c",
  null
  
)

export default component.exports